'use client'
import React, { useState, useEffect, useCallback, useRef } from 'react';
import MapProjectCard from '@components/MapProjectCard'
import { GoogleMap, Marker, LoadScript, InfoWindow, Polygon } from "@react-google-maps/api";
import { getProjectCardInfo } from '@services/getProjectCardInfo';
import { getMapLanguage, getMapRegion } from '@utils'
import { company } from '@constants/company';

const SearchProjectMap = ({ lang, dictionary, coordinates, hoveredProperty, zoomControl = true, latitude = company.OFFICE_LAT, longitude = company.OFFICE_LNG, geoJSON = [] }) => {
    const [center, setCenter] = useState({ latitude: Number(latitude), longitude: Number(longitude) });

    const [selectedMarker, setSelectedMarker] = useState({});
    const [selectedProperty, setSelectedProperty] = useState(null);
    const [markerHighlight, setMarkerHighlight] = useState(hoveredProperty)
    const [btsLat, setBtsLat] = useState(latitude)
    const [btsLng, setBtsLng] = useState(longitude)
    const [polygon, setPolygon] = useState(geoJSON)

    let mapLanguage = getMapLanguage(lang)
    let mapRegion = getMapRegion(lang)

    useEffect(() => {
        const setBtsLatLng = () => {
            setBtsLat(latitude)
            setBtsLng(longitude)
        }
        setBtsLatLng()
    }, [latitude, longitude])

    const mapRef = useRef(null);

    const selectMarker = useCallback(({ _id, latitude, longitude }) => {
        setCenter({})
        // setCenter({ latitude: Number(latitude) + 0.01, longitude: Number(longitude) })
        setSelectedMarker({ _id, latitude, longitude });
        // setCenter({ latitude: Number(latitude), longitude: Number(longitude) });
        // Get the map instance from the ref
        const map = mapRef.current;

        // Check if the map instance exists and is valid
        if (map && _id !== undefined) {
            // Create a LatLng object for the marker's position
            const markerPosition = new window.google.maps.LatLng(Number(latitude), Number(longitude));

            // Pan the map to the marker's position
            map.panTo(markerPosition);
        }
    }, []);

    useEffect(() => {
        const map = mapRef.current;
        const centerMapToBts = (lat, lng) => {
            if (map) {
                // setCenter({ latitude: Number(lat), longitude: Number(lng) })
                setCenter({})
                // Create a LatLng object for the marker's position
                const markerPosition = new window.google.maps.LatLng(Number(lat), Number(lng));

                // Pan the map to the marker's position
                map.panTo(markerPosition);
            }
        }
        centerMapToBts(latitude, longitude)
    }, [btsLat, btsLng])

    useEffect(() => {
        if (selectedMarker && selectedMarker._id !== undefined) {
            const getPropertyInfo = async () => {
                const result = await getProjectCardInfo(selectedMarker._id);

                setSelectedProperty(result);
            };

            getPropertyInfo();
        }
    }, [selectedMarker]);

    useEffect(() => {
        const highlightMarker = () => {
            setMarkerHighlight(hoveredProperty)
            // console.log(hoveredProperty)
        }
        highlightMarker()
    }, [hoveredProperty])

    const containerStyle = {
        width: '100%',
        height: '80vh',
    };

    const customMarkerIcon = {
        url: '/images/icons/marker3.svg', // Replace this with the URL of your custom PNG marker
    };

    const highlightMarkerIcon = {
        url: '/images/icons/marker4.svg', // Replace this with the URL of your custom PNG marker
    };

    const options = {
        disableDefaultUI: true, // This disables the default controls
        zoomControl: zoomControl, // Set to false to remove the zoom control
    };

    return (
        <div className=''>
            <LoadScript 
                googleMapsApiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API}
                loading="async"
                language={mapLanguage}
                region={mapRegion}
            >
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={{ lat: Number(center.latitude), lng: Number(center.longitude) }}
                    zoom={15}
                    options={options}
                    onLoad={(map) => {
                        mapRef.current = map;
                    }}
                >
                    {(polygon.length > 0) && (
                        <Polygon
                            paths={polygon}
                            options={{
                                fillColor: "#FF0000",
                                fillOpacity: 0.01,
                                strokeColor: "#FF0000",
                                strokeOpacity: 0.8,
                                strokeWeight: 2,
                            }}
                        />
                    )}
                    {coordinates && coordinates.length > 0 && (
                        coordinates.map(({ _id, latitude, longitude }) => (
                            <Marker
                                key={_id}
                                onClick={() => selectMarker({ _id, latitude, longitude })}
                                position={{ lat: Number(latitude), lng: Number(longitude) }}
                                icon={_id !== markerHighlight ? customMarkerIcon : highlightMarkerIcon}
                                zIndex={_id == markerHighlight ? 100 : 40}
                                className=' filter-maincolor'
                                scaledSize={20}
                            >
                                {selectedMarker._id !== undefined && selectedMarker._id === _id && selectedProperty && (
                                    <InfoWindow
                                        position={{ lat: Number(selectedMarker.latitude), lng: Number(selectedMarker.longitude) }}
                                        // anchor={selectedMarker}
                                        onCloseClick={() => {
                                            // When the InfoWindow is closed, clear the selected marker
                                            setSelectedMarker({});
                                        }}
                                    >
                                        {/* <div className='flex flex-col'>

                                            <h3>{selectedProperty.name}</h3>
                                        </div> */}
                                        <MapProjectCard project={selectedProperty} lang={lang} dictionary={dictionary} />
                                    </InfoWindow>
                                )}
                            </Marker>
                        ))
                    )}
                </GoogleMap>
            </LoadScript>
        </div>
    );
};

export default SearchProjectMap;
